<template> 
  <div class="router-front"></div>
  <div class="router">
  
  <router-view v-slot="{ Component, route }">
  <transition name="fade" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view>
  </div> 
  <div  class="router-backend"></div>
  </template>
  <script setup>
  import {reactive,provide,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
  import * as vueUse from "@vueuse/core";
  import Language from "@/hooks/language.js";
  import Router from "@/hooks/router.js";
  import bridge from "@/utils/sdkBridge.js";
  import * as request from "@/api/request";
  import * as utils from "@/utils";
  import * as _ from "lodash-es";
  import { useRoute } from 'vue-router';
 import useClipboard from "vue-clipboard3"

 const route = useRoute();
      const { initLang ,curLang, getLangTxt, langData} = Language();

      const routerData = {};
      const compData = {};
      const PAGE_DATA_LANG = {"default":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"Twitter"},{"type":"Line"},{"type":"Kakao"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"zh-CN":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"zh-TW":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"en-US":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"ja-JP":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Twitter"},{"type":"Line"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"ko-KR":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"Naver"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"th-TH":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"vi-VN":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"de-DE":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"fr-FR":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"ru-RU":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"es-ES":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"pt-PT":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"it-IT":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"tr-TR":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"pl-PL":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"id-ID":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false},"ar-SA":{"isLogin":false,"host":utils.getMainHost(),"pageId":"pnszd02","gameId":191,"activityName":"PNS恐怖游乐园组队活动","canReBind":false,"isEdit":true,"recentServerList":[],"myPackageList":[{time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"bagPopupState":false,"bindPopupState":false,"tipsPopupState":``,"infoPopupState":false,"inviteMessagePopupState":false,"roleName":"超级厉害角色","loginAccount":"账号名","isBind":true,"serverName":"S1","inviteCode":`ABCD`,"inputInviteCode":`123`,"lotteryTimes":0,"lotteryCost":0,"inviteCount":0,"expTotal":0,"luckyNum":`10`,"toInvitePopupState":false,"inviteLink":`https://www.37games.com`,"inviteBindPopupState":false,"inviteCodeUrl":`ABCD`,"tips":`tips`,"inviteLog":[{roleName: 'ABC', time: '2023-12-11 23:00:00'}],"activeInviteeText":`快来跟我组队吧！一起游戏拿大奖`,"inviteLogPopupState":false,"inviterTaskLogPopupState":false,"inviteeTaskLogPopupState":false,"inviteeOtherPopupState":false,"inviteeOther":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteeTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviterTaskLog":[{
      taskType: "invitee_pay_num",
      finishTime: "2019-01-01 00:00:00",
      exp: "100",
      arrayId: "0",
      roleName: "test11",
    }],"inviteRoleNameUrl":`name`,"bindExp":0,"propsPopupState":false,"seeGiftPopupState":false,"quanPopupState":false,"giftCodePopupState":false,"quanUseLink":`https://www.37games.com`,"exchangeLink":`https://gevents.pnsofficial.com/globalexchange/index.html?gameId=191`,"storeLink":`https://pay.pnsofficial.com/platform/officialStore.html?gameId=191`,"serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"curGiftName":"一个神奇的大礼包","seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"shareList":[{"type":"Facebook"},{"type":"VK"},{"type":"System"}],"FBAPPID":2303380839957579,"KAKAOKEY":``,"shareTitle":``,"shareContent":``,"shareImage":``,"currency":`USD`,"sharePopupBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170125008179793898.png`,"remainBigAwardCount":0,"showRate":false,"showStock":false,"materialPopupState":false,"shareColor":`#000000`,"previewPopup":``,"canExit":true,"teamSize":5,"curTeamSize":`2`,"isCaptain":false,"curLotteryCoupon":`0`,"teamPayTotal":`0`,"isMember":false,"exitTeamPopupState":false,"breakTeamPopupState":false,"curBagType":`all`,"teamInfoPopupState":false,"personalPayTotal":`0`,"taskLogPopupState":false,"taskLog":[],"ruleConfig":{
  captain: null,
  member: null
},"lotteryIcon":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716450675831-22.png`,"mainTitleColorUp":`#d1f3f9`,"mainTitleColorDown":`#e0e1db`,"canvasImg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726057740997-4.png`,"shareTicketPopupState":false,"rankLevel":`x`,"teamRankList":[
  { rank: "1", serverName: "S486", roleName: "role-1", payTotal: "0" }
],"soloRankList":[{rank:"1",serverName:"S486",roleName:'role-1', payTotal:'0'}],"showRankMoney":true,"lastTeamRankList":[],"lastSoloRankList":[],"lastRankPopupState":false,"curLastRankType":`team`,"showLastRank":false}};
      const pageData = reactive(PAGE_DATA_LANG[curLang] || PAGE_DATA_LANG['en-US']||{});
      let pagePlatform = "global"
      let pagePlatformId = 8;

      provide("pageData", pageData);

      if(pageData.gameId!==void 0 ){
        pageData.gameId = utils.getUrlParams("gameId") ||  utils.getUrlParams("gameID") ||  utils.getUrlParams("game_id") || pageData.gameId || ""
      }

      initLang();
      // 自定义setup - 开始
      const router = Router();
const {
  toClipboard
} = useClipboard();
// 如果是模版，就修改一个能用的活动标识
if (/^template/.test(pageData.pageId)) {
  pageData.pageId = "pnshszd01";
}

if (window.innerWidth < window.innerHeight && router.hasRoute("m")) {
  router.gotoRouter("/m");
}

window.activityDataLayer.push({
  eventName: "view_page",
  eventType: pageData.pageName,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});

const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global";

const defaultServerItem = [
  {
    sid: "",
    id: "",
    sname: getLangTxt("pleaseSelectServer")
  },
];
const defaultRoleItem = [
  {
    roleID: "",
    roleName: getLangTxt("pleaseSelectRole")
  },
];
// 记录礼包名
const giftInfo = reactive({
  lotteryList: [],
  inviteeTask: [],
  inviterTask: [],
  teamAward: [], // 组队奖励
  captainAward: [], // 队长奖励
  teamTask: [], // 队伍任务
  personalTask: [], // 个人任务
  teamRank: [], // 队伍排行
  soloRank: [], // 个人排行
});
const listData = reactive({
  mapList: [],
  lotteryList: [],
  inviterTask: [],
  inviteeTask: [],
  teamAward: [], // 组队奖励
  captainAward: [], // 队长奖励
  teamList: [], // 队伍人员
  teamTask: [], // 队伍任务
  personalTask: [], // 个人任务
  teamRank: [], // 队伍排行
  soloRank: [], // 个人排行
});
// 聚合分享相关
const shareLinkParamsMap = {
  Naver: "naver",
  VK: "vk",
  Line: "line",
  Twitter: "twitter",
  Facebook: "facebook",
  System: "other",
};
const shareInfo = {
  appId: pageData.FBAPPID,
  appKey: pageData.KAKAOKEY,
  aid: pageData.pageId,
  gameId: pageData.gameId,
  title: langData.mainTitle,
  content: langData.welcomeInvite,
  url: pageData.inviteLink,
  shareImageArr: [pageData.shareImage],
  shareSdkLoadedCallback: () => {
    // 脚本加载完成的回调
  },
  shareSuccessCallback: () => {
    // 分享成功的回调
  },
  shareFailCallback: () => {
    // 分享失败的回调
  },
};
// eslint-disable-next-line
const shareFactoryInst = new ShareFactory(shareInfo);
const canClickRefresh = ref(true);
const canClickInviteBind = ref(true);
const getDomain = (url) => {
  let domain = url.replace(/^(https?:\/\/)?(www\.)?/, "");

  // 截取主域部分
  domain = domain.split("/")[0];

  // 处理子域，只保留最后两个部分（主域和顶级域名）
  let parts = domain.split(".");
  if (parts.length >= 2) {
    domain = parts[parts.length - 2] + "." + parts[parts.length - 1];
  }

  return domain;
};
const getCurLink = (link) => {
  let addParams = {
    gameId: pageData.gameId,
    language: curLang,
  };
  // 替换līnk中的域名
  // let curHost = utils.getMainHost();
  // if (link && link.split(".")) {
  //   let linkHost = getDomain(link);
  //   if (linkHost !== curHost) {
  //     link = link.replace(linkHost, curHost);
  //   }
  // }
  if (!link) return "";
  return utils.getStoreLinkWithCidScid({
    link,
    paramsObj: addParams,
    pageId: pageData.pageId,
  });
};

const resetData = () => {
  pageData.isEdit = false;
  pageData.isLogin = false;
  pageData.inviteCode = '';
  pageData.inputInviteCode = '';
  pageData.inputCodeUrl = utils.getUrlParams("inviteCode")
  pageData.loginAccount = "";
  pageData.isBind = false;
  pageData.serverName = "";
  pageData.roleName = "";
  pageData.signTime = 0;
  pageData.lotteryTime = 0;
  pageData.bindExp = 0;
  pageData.couponCount = 0;
  pageData.curTeamSize = 0;
  pageData.currency = "";
  pageData.money = "";
  pageData.inviteRoleNameUrl = '';
  pageData.infoPopupState = false;
  pageData.bindPopupState = false;
  pageData.bagPopupState = false;
  pageData.tipsPopupState = false;
  pageData.propsPopupState = false;
  pageData.quanPopupState = false;
  pageData.giftCodePopupState = false;
  pageData.toInvitePopupState = false;
  pageData.inviteMessagePopupState = false;
  pageData.inviteBindPopupState = false;
  pageData.inviterTaskLogPopupState = false;
  pageData.inviteLogPopupState = false;
  pageData.inviteeTaskLogPopupState = false;
  pageData.inviteeOtherPopupState = false;
  pageData.bindSuccPopupState = false;
  pageData.inviteeOther = [];
  pageData.inviteeTaskLog = [];
  pageData.inviterTaskLog = [];
  pageData.inviteLog = [];
  pageData.firstPayType = "sendVt";
  pageData.firstPayState = 0;
  pageData.myPackageList = [];
  pageData.curGiftPic = "";
  pageData.curGiftName = "";
  pageData.tips = "";
  pageData.currency = "";
  pageData.serverList = [];
  pageData.recentServerList = [];
  pageData.roleList = _.cloneDeep(defaultRoleItem);
  pageData.selectServerIndex = 0;
  pageData.selectRoleIndex = 0;
  pageData.storeLink = getCurLink(pageData.storeLink);
  pageData.exchangeLink = getCurLink(pageData.exchangeLink);
  pageData.previewPopup = "";
  pageData.teamRankList = [];
  pageData.soloRankList = [];
  pageData.lastTeamRankList = [];
  pageData.lastSoloRankList = [];
};

const init = async () => {
  let loginState = await getUserJson();
  if (loginState) {
    window.activityDataLayer.push({
      eventName: "login",
      loginAccount: pageData.loginAccount,
      uid: pageData.uid,
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
  }
  pageData.inviteLink = window.globalGetGotoLink({link:window.location.href,hideScid:true}); // 默认分享链接
  pageData.inviteCodeUrl = utils.getUrlParams("inviteCode");
  pageData.inviteRoleNameUrl = decodeURIComponent(utils.getUrlParams("inviteRoleName"))
  initActivity();
  initShare();
};
// 领奖接口
const getAward = async (type, key) => {
  // type枚举值：team_award、captain_award、team_task、personal_task
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=award`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=award`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=award`,
  };
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      type,
      key,
    }),
  });
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
    return res;
  }
  const awardData = res.data.awardData;
  const giftMap = {
    team_award: giftInfo.teamAward,
    captain_award: giftInfo.captainAward,
    team_task: giftInfo.teamTask,
    personal_task: giftInfo.personalTask,
  };
  const taskList = giftMap[awardData.type];
  let curItem = taskList.find((item) => item.key == awardData.key);
  showGetSucc(
    res.data.awardData.awardType,
    '',
    awardData.card || curItem.awardDetail
  );
  initActivity();
  return res;
};
const getUserJson = async () => {
  const link = {
    gm99: `https://passport.gm99.com/ajax/get_user_json`,
    global: `https://gpassport.${utils.getMainHost()}/center/ajax/get_user_json`,
    omnion: `https://gpassport.${utils.getMainHost()}/center/ajax/get_user_json`,
  };
  let res = await request.getJSON(link[curPlatform]);
  if (res.result == 1) {
    pageData.loginAccount = res.data.LOGIN_ACCOUNT;
    pageData.isLogin = true;
    pageData.uid = res.data.UID || res.data.USER_ID;
  }
  return res && res.result == 1;
};

const initActivity = async () => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=getConfig`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getConfig`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getConfig`,
  };
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
      isFromGame: bridge.runInsdk() ? 1 : 0,
    }),
  });
  if (res?.result != 1) {
    showTips(getLangTxt(res?.code, getLangTxt("common")), res.code);
    return;
  }
  if (res?.result == 1) {
    if (res.data.roleInfo?.role_id) {
      pageData.roleName = res.data.roleInfo.role_name;
      pageData.serverName = res.data.roleInfo.server_name;
      pageData.isBind = true;
      pageData.canReBind = !!+res.data?.switch_role;
      try {
        window.__updatePointUploadCookie(
          "role_id",
          res.data.roleInfo.role_id
        );
        window.__updatePointUploadCookie(
          "role_name",
          res.data.roleInfo.role_name
        );
        window.__updatePointUploadCookie(
          "server_id",
          res.data.roleInfo.server_id
        );
      } catch (error) {}
    }

    pageData.luckyNum = res.data.luckyNum || 0;
    pageData.expTotal = res.data.expTotal || 0;
    pageData.inviteCount = res.data.inviteCount || 0;
    pageData.lotteryCost = res.data.lotteryCost || 0;
    pageData.lotteryTimes = res.data.lotteryTimes || 0;
    // pageData.inputInviteCode = res.data.inputInviteCode || "";
    pageData.inviteCode = res.data.teamCode || "";
    pageData.inviteLog = res.data.inviteLog || [];
    pageData.currency = res.data.currency || '';
    pageData.remainBigAwardCount = res.data.remainBigAwardCount || 0
    pageData.canExit = res.data.canExit;
    giftInfo.bigAwardId = res.data.bigAwardId;
    giftInfo.smallAwardId = res.data.littleAwardId;
    giftInfo.lotteryList = res.data.lotteryAwardArr;
    listData.lotteryList = res.data.lotteryAwardArr || [];
    listData.inviterTask = res.data?.taskList?.inviterTask;
    listData.inviteeTask = res.data?.taskList?.inviteeTask;
    listData.teamAward = res.data?.teamAward; // 组队奖励
    listData.captainAward = res.data?.captainAward; // 队长奖励
    listData.teamList = res.data?.teamList; // 组队列表
    listData.teamTask = res.data?.teamTask; // 组队任务
    listData.personalTask = res.data?.personalTask; // 个人任务
    listData.teamRank = res.data?.teamPayRankAward; // 组队排行
    listData.soloRank = res.data?.personalPayRankAward; // 个人排行
    pageData.curTeamSize = res.data?.teamSize; // 当前小队数量
    pageData.teamSize = res.data?.maxTeamSize; // 小队最大数量
    pageData.isCaptain = !!res.data?.isCaptain; // 是否是队长
    pageData.isMember = !!res.data?.isMember; // 是否为队员
    pageData.teamPayTotal = res.data?.teamPayTotal; // 小队总支付金额
    pageData.personalPayTotal = res.data?.personalPayTotal; // 个人总支付金额
    pageData.curLotteryCoupon = res.data?.ticket; // 抽奖券
    pageData.canReBind = res.data?.switchRole;
    pageData.bigAwardEmpty = res.data?.bigAwardEmpty
    pageData.isBigAwardGot = res.data?.isBigAward;
    pageData.isLittleLuckyAwardGot = res.data?.isLittleLuckyAward;
    pageData.lotteryAddNum = res.data?.lotteryAddNum;
    pageData.lotteryTotalNeedNum = res.data?.lotteryTotalNeedNum;
    pageData.showLucky = !!res.data?.showLucky;
    pageData.showRate = !!res.data?.showRate;
    pageData.showStock = !!res.data?.showStock;
    pageData.ruleConfig = res.data?.rule;
    pageData.rankLevel = res.data?.rankConfig?.rank_pick_limit;
    pageData.showRankMoney = res.data?.rankConfig?.is_show_rank;
    pageData.showLastRank = res.data?.monthReset;
    if (
      !pageData.isCaptain &&
      !pageData.isMember &&
      !pageData.inputInviteCode.length &&
      utils.getUrlParams("inviteCode") &&
      utils.getUrlParams("inviteCode") != pageData.inviteCode
    ) {
      pageData.inviteMessagePopupState = true;
    }
  }
};
const getTaskLog = async () => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=taskLog`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=taskLog`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
          pageData.pageId
        }&action=taskLog`,
  };
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      type: pageData.curBagType,
    }),
  });
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
    return;
  }
  if (res.result == 1) {
    pageData.taskLog = res.data.map((item) => {
      let name = "";
      if (item.key) {
        name = giftInfo[
          pageData.curBagType == "team_task" ? "teamTask" : "personalTask"
        ].find((task) => task.key == item.key).taskName;
      }
      return {
        ...item,
        name: name || langData[item.sub_task_type],
      };
    });
  }
};
watch(
  () => pageData.taskLogPopupState,
  (newVal) => {
    if (newVal) {
      getTaskLog();
    }
  }
);
watch(
  async () => pageData.bagPopupState,
    () => {
      if (!pageData.bagPopupState) return;
      getPackageList();
    }
);
watch(
  async () => pageData.lastRankPopupState,
    () => {
      if (!pageData.lastRankPopupState) return;
      getLastRankList();
    }
);
const inviteBind = async (code) => {
  if (!checkIsLogin()) return;
  if (!checkIsBind()) return;
  if (!canClickInviteBind.value) {
    return;
  }
  canClickInviteBind.value = false;
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=joinTeam`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=joinTeam`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=joinTeam`,
  };
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      team_code: code,
    }),
  });
  canClickInviteBind.value = true;
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
    window.activityDataLayer.push({
      eventName: "invite_failed",
      eventValue: code,
      eventReason: `${getLangTxt(res.code, getLangTxt("common"))}[${res.code}]`,
      eventType: res.code,
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    return;
  }
  showTips(langData.joinSuccessTips);
  pageData.inviteMessagePopupState = false;
  initActivity();
};
// 门票分享
const ticketShare = async () => {
  const shareParams = {
    cid: "ticketShare",
  };
  let shareLink = utils.updateLinkParams(window.location.href, shareParams);
            shareLink = window.globalGetGotoLink({link:shareLink});
            
  // 弹窗显示邀请码
  const shortLinkRes = await window.getPlatformShortLink(
    replaceLinkToPc(shareLink)
  );
  if (+shortLinkRes.result === 1) {
    window.activityDataLayer.push({
      eventName: "shortLinkSuccess",
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    pageData.inviteLink = shortLinkRes.data;
  } else {
    window.activityDataLayer.push({
      eventName: "shortLinkFail",
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    pageData.inviteLink = shareLink;
    console.error(shortLinkRes);
  }
  document.querySelector("#codeWrap").style.display = "none";
  shareFactoryInst.batchSet({
    url: pageData.inviteLink,
    content: langData.copyTag,
  });
  shareFactoryInst.showPopup();
};
// 短链生成还不能支持自动化的移动端路由，自动化移动端页面先用PC的链接路由生成短链。
const replaceLinkToPc = (link) => {
  // 如果链接上带有/m的路由，需要先移除/m，
  if (!link) return link;
  if (link.indexOf(`${pageData.pageId}/m`) > -1) {
    link = link.replace(`${pageData.pageId}/m`, `${pageData.pageId}/`);
  }
  console.log(link);
  return link;
};
const openInvitePanel = async (isShare = false) => {
  if (!checkIsLogin()) return;
  if (!checkIsBind()) return;
  // 新增isShare参数区分当前是分享还是邀请，分享时不需要邀请码
  const shareParams = isShare ? {
    cid: "pageShare"
  } : {
    inviteCode: pageData.inviteCode,
    inviteRoleName: encodeURIComponent(pageData.roleName),
  };
  const shareLink = utils.updateLinkParams(
    window.location.href,
    shareParams
  );
  // 弹窗显示邀请码
  const shortLinkRes = await window.getPlatformShortLink(replaceLinkToPc(shareLink));
  if (+shortLinkRes.result === 1) {
    window.activityDataLayer.push({
      eventName: "shortLinkSuccess",
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    pageData.inviteLink = shortLinkRes.data;
  } else {
    window.activityDataLayer.push({
      eventName: "shortLinkFail",
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    pageData.inviteLink = shareLink;
    console.error(shortLinkRes);
  }
  // 新增isShare参数区分当前是分享还是邀请，分享时不显示邀请码
  document.querySelector("#codeWrap").style.display = isShare ?
    "none" :
    "block";
  document.querySelector("#inviteCode").innerText = pageData.inviteCode;
  document.querySelector("#inviteLink").innerText = pageData.inviteLink;
  shareFactoryInst.batchSet({
    url: pageData.inviteLink,
  });
  shareFactoryInst.showPopup();
  const inviteLink = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=shareTeam`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
            pageData.pageId
          }&action=shareTeam`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
            pageData.pageId
          }&action=shareTeam`,
  };
  let inviteRes = await request.getJSON(inviteLink[curPlatform]);
  if (inviteRes.result != 1) {
    showTips(
      getLangTxt(inviteRes.code, getLangTxt("common")),
      inviteRes.code
    );
    return;
  }
};
const getInviteText = (taskItem) => {
  return (taskItem.title || '').replace("XXX", taskItem?.textArr?.[0] || "");
};
const getPackageList = async () => {
  if (!checkIsLogin()) return;
  if (!checkIsBind()) return;
  pageData.myPackageList = [];
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=awardLog`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=awardLog`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=awardLog`,
  };
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
      type: pageData.curBagType,
    }),
  });
  if (res.result == 1) {
    let curBagData = res.data || [];
    pageData.myPackageList.push(...curBagData);
    pageData.myPackageList.forEach((item) => {
      if (item.type === "team_award") {
        item.award_name =
          giftInfo.teamAward.find((award) => award.key === item.key)
          ?.awardDetail || "";
      }
      if (item.type === 'captain_award') {
        item.award_name =
          giftInfo.captainAward.find((award) => award.key === item.key)
          ?.awardDetail || "";
      }
      if (item.type === "team_task") {
        item.award_name =
          giftInfo.teamTask.find((award) => award.key === item.key)
          ?.awardDetail || "";
      }
      if (item.type === "personal_task") {
        item.award_name =
          giftInfo.personalTask.find((award) => award.key === item.key)
          ?.awardDetail || "";
      }
      if (item.type === "lottery") {
        item.award_name =
          giftInfo.lotteryList.find((award) => award.id == item.key)
          ?.awardDetail || "";
      }
      if (item.type === "team_pay_rank_award") {
        item.award_name = giftInfo.teamRank.find(
          (award) => award.key == item.key
        )?.name || "";
      }
      if (item.type === "personal_pay_rank_award") {
        item.award_name = giftInfo.soloRank.find(
          (award) => award.key == item.key
        )?.name || "";
      }
    });
  }
};
// 获取上期榜单
const getLastRankList = async () => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=getLastPayRank`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getLastPayRank`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getLastPayRank`,
  };
  let res = await request.getJSON(link[curPlatform]);
  if (res.result == 1) {
    pageData.lastTeamRankList = res.data.team || [];
    pageData.lastSoloRankList = res.data.personal || [];
  }
};
resetData();
const checkIsLogin = () => {
                    if (pageData.isLogin) return true
                    window.location.href = utils.getLoginUrlApi(pagePlatform, pageData.gameId, curLang)
                    return false
                  }

const checkIsBind = () => {
  if (pageData.isBind) return true;
  pageData.bindPopupState = true;
  return false;
};

const showTips = (txt, code) => {
  // 若状态码[-21016,-21011]区间则提示langData.limitCondition
  if (+code >= -21016 && +code <= -21011) {
    txt = langData.limitCondition;
  }
  pageData.tips = `${txt} ${code ? `[${code}]` : ""}`;
  pageData.tipsPopupState = true;
};

const showGetSucc = (type, pic, name) => {
  if (type == "sendVt" || type == "sendTicket") {
    pageData.propsPopupState = true;
  } else if (type == "sendSerial") {
    pageData.giftCodePopupState = true;
  } else if (type == "sendMaterial") {
    pageData.materialPopupState = true;
  } else {
    pageData.quanPopupState = true;
  }
  pageData.curGiftPic = pic;
  pageData.curGiftName = name;
};
const initShare = () => {
  const initShareArr = pageData.shareList.map((item) => {
    return item.type;
  });

  initShareArr.forEach((item) => {
    // 判断是否支持系统分享
    if (item === "System") {
      // eslint-disable-next-line
      const shareSystemInst = new ShareSystem();
      if (!shareSystemInst.isSupport()) {
        return;
      }
    }
    const shareFactoryItem = shareFactoryInst.createShareInst({
      // eslint-disable-next-line
      type: ShareFactory.shareType[item],
    });

    try {
      const shortLink = pageData.inviteLink;
      if (item === "Naver") {
        // Naver分享标题需要加上链接
        shareFactoryItem.setTitle(`${pageData.shareTitle}${shortLink}`);
      }
      shareFactoryItem.setUrl(shortLink);
    } catch (e) {
      console.error(e);
    }
  });
  // 竖版：u_c_QYZ7409，横版：u_c_DN4226
  shareFactoryInst.mountPopup({
    ele: document.querySelector("#u_c_QYZ7409") ?
      "#u_c_QYZ7409" : "#u_c_DN4226",
    themeMode: "light", // 可选，默认主题，light亮色，dark暗色
    iconRowNum: 4, // 可选，每一行显示的分享数量
    showText: true, // 可选，是否展示渠道的分享名字
    autoHidePopup: false, // 可选，是否在点击分享图标后自动隐藏弹窗
    popupBackground: `url(${pageData.sharePopupBg})`,
    titleSlot: `
        <p style="padding: 0 10px">${langData.welcomeTeamInvite}</p>
        <div id="codeWrap" style="width: 86%; margin: 20px auto 0; text-align: left; font-size: calc(22px * var(--share-px-unit));font-weight: 400">
          <div>${langData.teamCode}：<span id="inviteCode">${pageData.inviteCode}</span></div>
          <div style="overflow: auto;margin-top: 5px; white-space: pre">${langData.teamAddress}：<span id="inviteLink">${pageData.inviteLink}</span></div>
        </div>
        `,
    btnSlot: `
        <div id="copyTips" style="font-size:calc(22px * var(--share-px-unit)); text-align:center; margin-bottom: 10px"></div>
        <a
        id="copyBtn"
        href="javascript:;"
        style="
          position: relative;
          height: calc(50px * var(--share-px-unit));
          border-radius: 10px;
          font-size: calc(22px * var(--share-px-unit));
          margin-bottom: 5px;
          padding: 0 22px;
          background: #9c8d8d;
          color: #000;
          display: flex;
          justify-content: center;
          align-items: center;
          text-decoration: none;
        "
      >
        ${langData.copy}
      </a>
      <p style="font-size:calc(22px * var(--share-px-unit)); text-align:center">${bridge.runInsdk() ? langData.shareAgain : ""}</p>`,
    useCopyBtn: false, // 可选，是否展示复制链接按钮
    useSaveBtn: false, // 可选，是否展示保存到相册按钮
    textColor: pageData.shareColor, // 可选，弹窗文案颜色
    // 可选，弹窗按钮背景，该值直接传到样式的background里
    btnBackground: `#9c8d8d`,
  });
  shareFactoryInst.setPopupLang(curLang);
  document.querySelector("#copyBtn").addEventListener("click", async () => {
    await toClipboard(`${langData.welcomeTeamInvite}
${pageData.inviteCode ? langData.teamCode + ": " + pageData.inviteCode : ""}
${pageData.inviteLink ? langData.teamAddress + ": " + pageData.inviteLink : ""}
        `);
    document.querySelector("#copyTips").innerText = langData.copySucc;
    await utils.sleep(2);
    document.querySelector("#copyTips").innerText = "";
  });
};
provide("checkIsLogin", checkIsLogin);
provide("checkIsBind", checkIsBind);
provide("listData", listData);
provide("initActivity", initActivity);
provide("canClickRefresh", canClickRefresh);
provide("showTips", showTips);
provide("showGetSucc", showGetSucc);
provide("init", init);
provide("giftInfo", giftInfo);
provide("getCurLink", getCurLink);
provide("inviteBind", inviteBind)
provide("openInvitePanel", openInvitePanel)
provide("getInviteText", getInviteText)
provide("getAward", getAward);
provide("ticketShare", ticketShare);
      // 自定义setup - 结束


  </script>
  <style lang="scss">
    @import 'assets/common.scss';

    #sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
  </style>
  